// extracted by mini-css-extract-plugin
export default {"text":"PackageTitle_text__ZQfXn","inactiveText":"PackageTitle_inactiveText__P6R0X"};